/** 账单页尾银行信息：字段定义与标签（中/英/双语） */

export const PAYMENT_FOOTER_LABEL_MODES = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: '英文' },
  { value: 'bilingual', label: '中英文' }
]

const USD_BANK_FIELDS = [
  { key: 'accountName', zh: '银行户名', en: 'BENEFICIARY NAME' },
  { key: 'accountNo', zh: '账号', en: 'ACCOUNT NO' },
  { key: 'bankName', zh: '银行名称', en: 'BANK NAME' },
  { key: 'bankAddress', zh: '银行地址', en: 'ADDRESS' },
  { key: 'swiftCode', zh: '银行代码(SWIFT)', en: 'SWIFT' }
]

const CNY_BANK_FIELDS = [
  { key: 'accountName', zh: '户名', en: 'BENEFICIARY NAME' },
  { key: 'bankName', zh: '开户行', en: 'BANK NAME' },
  { key: 'accountNo', zh: '账号', en: 'ACCOUNT NO' }
]

export function getPaymentFooterFieldDefs (accountKind = 'cny') {
  return accountKind === 'usd' ? USD_BANK_FIELDS : CNY_BANK_FIELDS
}

export function formatPaymentFooterLabel (field, labelMode = 'zh') {
  if (!field) return ''
  if (labelMode === 'en') return field.en
  if (labelMode === 'bilingual') return `${field.zh} / ${field.en}`
  return field.zh
}

/** 银行信息标签后加全角冒号（已有冒号则不重复） */
export function formatPaymentFooterLabelWithColon (field, labelMode = 'zh') {
  const label = formatPaymentFooterLabel(field, labelMode)
  if (!label) return ''
  return /[:：]$/.test(label) ? label : `${label}：`
}

export function normalizePaymentFooterAccount (acc = {}, idx = 0) {
  const kind = acc.accountKind === 'usd' ? 'usd' : 'cny'
  return {
    key: acc.key || `acc_${Date.now()}_${idx}`,
    label: acc.label || '',
    accountKind: kind,
    accountName: acc.accountName || '',
    bankName: acc.bankName || '',
    accountNo: acc.accountNo || '',
    bankAddress: acc.bankAddress || '',
    swiftCode: acc.swiftCode || '',
    is_default: Boolean(acc.is_default),
    is_active: acc.is_active !== false
  }
}

export function resolvePaymentFooterAccountKind (pf = {}) {
  const key = pf.selectedAccountKey
  const hit = (pf.accounts || []).find((x) => x.key === key && x.is_active !== false)
  if (hit?.accountKind === 'usd') return 'usd'
  if (hit?.accountKind === 'cny') return 'cny'
  if (pf.accountKind === 'usd') return 'usd'
  return 'cny'
}

export function resolvePaymentFooterFieldValue (pf = {}, fieldKey) {
  if (!pf || !fieldKey) return ''
  if (pf[fieldKey]) return String(pf[fieldKey])
  const selected = (pf.accounts || []).find((x) => x.key === pf.selectedAccountKey)
  if (!selected) return ''
  return selected[fieldKey] != null ? String(selected[fieldKey]) : ''
}

/** 同步选中账户到模板页尾可编辑字段 */
export function syncPaymentFooterFromAccount (pf, account) {
  if (!pf || !account) return
  pf.accountKind = account.accountKind === 'usd' ? 'usd' : 'cny'
  pf.accountName = account.accountName || ''
  pf.bankName = account.bankName || ''
  pf.accountNo = account.accountNo || ''
  pf.bankAddress = account.bankAddress || ''
  pf.swiftCode = account.swiftCode || ''
}

export function buildPaymentFooterDisplayLines (pf = {}, resolveField) {
  const resolver = typeof resolveField === 'function'
    ? resolveField
    : (key) => resolvePaymentFooterFieldValue(pf, key)
  const labelMode = pf.labelMode || 'zh'
  const kind = resolvePaymentFooterAccountKind(pf)
  const fields = getPaymentFooterFieldDefs(kind)
  return fields.map((f) => {
    const raw = resolver(f.key)
    const value = raw != null && String(raw).trim() !== '' ? String(raw).trim() : '-'
    return {
      key: f.key,
      label: formatPaymentFooterLabelWithColon(f, labelMode),
      value
    }
  })
}

export function paymentFooterReservedLineCount (pf = {}) {
  if (!pf?.enabled) return 0
  const kind = resolvePaymentFooterAccountKind(pf)
  return 1 + getPaymentFooterFieldDefs(kind).length
}
